import { useReactiveVar } from '@bestseller/retail-planning.utils.reactive-vars';
import { useMemo } from 'react';
import { ScopeEnum } from 'src/domain';
import { selectedPartnerVar } from 'src/infrastructure/local_state';
import { useChainId } from './chain';
import { useClusterId } from './cluster/useClusterId';
import { useCompositePartner } from './partner/useCompositePartner';
import { useStoreId } from './store/useStoreId';
import { useScope } from './useScope';

export const useCurrentId = () => {
    const scope = useScope();
    const [selectedPartner] = useReactiveVar(selectedPartnerVar);
    const storeId = useStoreId();
    const clusterId = useClusterId(selectedPartner);
    const compositePartner = useCompositePartner(selectedPartner);
    const chainId = useChainId();

    return useMemo(() => {
        switch (scope) {
            case ScopeEnum.STORE:
                return Number(storeId);
            case ScopeEnum.CLUSTER:
                return clusterId;
            case ScopeEnum.PARTNER:
                return compositePartner?.id;
            case ScopeEnum.GLOBAL:
                return chainId;
            default:
                return null;
        }
    }, [chainId, clusterId, compositePartner, scope, storeId]);
};
